import { useTopLabel } from "@/components/AppHooks"
import { IconArrowBack } from "@/components/icon/tanqueray"
import { UtilPrevBack } from "@/shared/utils";

export function TanquerayBack(props: {
    color?: string;
    onClick?: () => void;
}) {
    const topLabel = useTopLabel()
    return (
        <div className="tanqueray-top-back-container" onClick={() => {
            if (props.onClick) {
                props.onClick()
                return
            }
            UtilPrevBack().then((res) => {
                if (res) {
                    window.history.back()
                }
            })
        }}>
            <IconArrowBack className={props.color || '#2c2c2c'} />
            {typeof topLabel.content === 'string' && <span style={{ color: props.color || '#2c2c2c' }}>{topLabel.content}</span>}
        </div>
    )
}